import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {setBucket, addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';


const usersLoading = (loadCriteria) => ({
    type: ActionTypes.USERS_LOADING,
    payload: loadCriteria
});

const usersFailed = (errmess) => ({
    type: ActionTypes.USERS_FAILED,
    payload: errmess
});

const addUsers = (users) => ({
    type: ActionTypes.ADD_USERS,
    payload: users
});

const addUser = (user) => ({
    type: ActionTypes.ADD_USER,
    payload: user
});


/**
 * Fetch all the users for a clientId.
 * If clientId is null, bring all users
 * 
 * @returns 
 */
export const fetchUsers = (clientId) => (dispatch) => {

    var url;
    if(clientId) {
        const urlParams = new URLSearchParams({ clientId: clientId });
        url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}?${urlParams}`);
    }
    else{
        url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}`);
    }
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(usersLoading({clientId: clientId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(users => dispatch(addUsers(users)))
        .catch(error => {
            dispatch(usersFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Utilizatorilor" } }));
        });
}
  

export const postUser = (user) => (dispatch) => {
    user.createDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.USERS, {
        method: "POST",
        body: JSON.stringify(user),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(nUser => {
            console.log("1");
            // dispatch(createUser());
            console.log("2");

            return dispatch(addUser(nUser));
        })
        .then(userAction => dispatch(setBucket({ mostRecentUserId: userAction.payload.id, snackbar: { open: true, severity: "success", message: "Utilizatorul a fost creat cu succes" } })))
        .catch(error => {
            dispatch(usersFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Utilizatorului" } }));
        })
}


export const putUser = (user) => (dispatch) => {
    user.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.USERS + `/${user.id}`, {
        method: "PUT",
        body: JSON.stringify(user),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(user => dispatch(updateUser(user)))
        .then(usrAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Utilizatorul salvat cu succes" } })))
        .catch(error => {
            dispatch(usersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii Utilizatorului" } }));
        });
}


export const patchUser = (user, clientId) => (dispatch) => {
    user.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    // const urlParams = new URLSearchParams({ clientId: user.generalSection.clientId });
    const urlParams = new URLSearchParams({ clientId: clientId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}/${user.id}?${urlParams}`);

    return fetch(url.href, {
            method: "PATCH",
        body: JSON.stringify(user),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(user => dispatch(updateUser(user)))
        .then(usrAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Utilizatorului actualizate cu succes" } })))
        .catch(error => {
            dispatch(usersFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Utilizatorului" } }));
        });
}


const updateUser = (user) => ({
    type: ActionTypes.UPDATE_USER,
    payload: user
});
  

export const deleteUser = (userId, clientId) => (dispatch) => {

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    const urlParams = new URLSearchParams({ clientId: clientId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}/${userId}?${urlParams}`);

    return fetch(url.href, {
        method: "DELETE",
        body: JSON.stringify({}),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(() => dispatch(removeUser(userId)))
        .then(usrAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Utilizatorului sterse cu succes" } })))
        .catch(error => {
            dispatch(usersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul stergerii Utilizatorului" } }));
        });
}

const removeUser = (userId) => ({
    type: ActionTypes.DELETE_USER,
    payload: userId
});
